import React, { useEffect, useState } from "react";

import { Navigate } from "react-router-dom";

import axios from "axios";

const API =
  process.env.NODE_ENV === "production"
    ? "https://gj-frio-industrial-api.onrender.com"
    : "http://localhost:4000";

export default function RutaAdmin({ children }) {
  const [estado, setEstado] = useState("verificando");

  useEffect(() => {
    let activo = true;

    const verificarSesion = async () => {
      const token = sessionStorage.getItem("gj_admin_token");

      if (!token) {
        if (activo) {
          setEstado("no-autorizado");
        }

        return;
      }

      try {
        await axios.get(`${API}/auth/verificar`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (activo) {
          setEstado("autorizado");
        }
      } catch {
        sessionStorage.removeItem("gj_admin_token");

        sessionStorage.removeItem("gj_admin_usuario");

        if (activo) {
          setEstado("no-autorizado");
        }
      }
    };

    verificarSesion();

    return () => {
      activo = false;
    };
  }, []);

  if (estado === "verificando") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f7fa",
        }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status"></div>

          <div
            className="mt-3 text-secondary"
            style={{
              fontSize: "13px",
            }}
          >
            Verificando sesión...
          </div>
        </div>
      </div>
    );
  }

  if (estado === "no-autorizado") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
